import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { copyTextToClipboard } from "@/lib/copyTextToClipboard";
import { Copy } from "lucide-react";
import { toast } from "sonner";

type Props = {
  url: string;
};

export async function copyProposalCustomerLink(
  url: string,
  options?: { successMessage?: string },
): Promise<boolean> {
  const trimmed = url.trim();
  if (!trimmed) {
    toast.error("Proposal link is not available yet.");
    return false;
  }
  const copied = await copyTextToClipboard(trimmed);
  if (copied) {
    toast.success(options?.successMessage ?? "LINK HAS BEEN COPIED");
  } else {
    toast.message("Link is ready — select it below and copy manually.");
  }
  return copied;
}

export default function ProposalCustomerLinkShareField({ url }: Props) {
  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-muted-foreground">Customer proposal link (Link B)</p>
      <div className="flex gap-2">
        <Input
          readOnly
          value={url}
          className="font-mono text-xs"
          onFocus={(event) => event.currentTarget.select()}
        />
        <Button
          type="button"
          variant="outline"
          size="icon"
          aria-label="Copy proposal link"
          onClick={() => void copyProposalCustomerLink(url)}
        >
          <Copy className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
